export default "__VITE_ASSET__DyBqYixb__"